import { ToastManager } from '../components/Toast';
import { AuthStore } from '../../core/store/authStore';
import { AuthModal } from '../components/AuthModal';
import { DialogManager } from '../components/DialogManager';

import { NICHE_REGISTRY } from '../../engine/NicheRegistry';
import { ApiClient } from '../../services/ApiClient';
import { supabase } from '../../services/supabase';

export const NICHE_GAMES_LIST = NICHE_REGISTRY;

export class NicheHubView {
  private static activeSubTab: 'experimental' | 'importer' | 'ideas' = 'experimental';
  private static expPage = 1;
  private static impPage = 1;
  private static readonly itemsPerPage = 12;
    private static externalGames: { title: string; url: string; icon: string }[] = [
    { title: 'Agar.io', url: 'https://agar.io/', icon: '🔵' },
    { title: 'Slither.io', url: 'https://slither.io/', icon: '🐍' },
    { title: 'Krunker.io', url: 'https://krunker.io/', icon: '🔫' },
    { title: 'Skribbl.io', url: 'https://skribbl.io/', icon: '🎨' },
    { title: 'Hole.io', url: 'https://hole-io.com/', icon: '🕳️' },
    { title: 'Paper.io 2', url: 'https://paper-io.com/', icon: '📄' },
    { title: 'Zombs Royale', url: 'https://zombsroyale.io/', icon: '🪂' },
    { title: 'Shell Shockers', url: 'https://shellshock.io/', icon: '🥚' },
    { title: 'Venge.io', url: 'https://venge.io/', icon: '🤖' },
    { title: 'Little Alchemy 2', url: 'https://littlealchemy2.com/', icon: '⚗️' },
    { title: 'Run 3', url: 'https://run3.io/', icon: '🏃' },
    { title: 'Retro Bowl', url: 'https://retrobowl.me/', icon: '🏈' },
    { title: 'Smash Karts', url: 'https://smashkarts.io/', icon: '🏎️' },
    { title: 'Ev.io', url: 'https://ev.io/', icon: '🚀' },
    { title: '1v1.lol', url: 'https://1v1.lol/', icon: '🎯' },
    { title: 'Repuls.io', url: 'https://repuls.io/', icon: '🔫' },
    { title: 'Mini Royale', url: 'https://miniroyale.io/', icon: '🪖' },
    { title: 'Kour.io', url: 'https://kour.io/', icon: '🔥' },
    { title: 'Merc Zone', url: 'https://merc.zone/', icon: '⚔️' },
    { title: 'Gats.io', url: 'https://gats.io/', icon: '🛡️' },
    { title: 'Deeeep.io', url: 'https://deeeep.io/', icon: '🐟' },
    { title: 'Mope.io', url: 'https://mope.io/', icon: '🐭' },
    { title: 'Starve.io', url: 'https://starve.io/', icon: '🔥' },
    { title: 'Devast.io', url: 'https://devast.io/', icon: '🏕️' },
    { title: 'MooMoo.io', url: 'https://moomoo.io/', icon: '🐮' },
    { title: 'Zombs.io', url: 'https://zombs.io/', icon: '🧟' },
    { title: 'Lordz.io', url: 'https://lordz.io/', icon: '👑' },
    { title: 'Brutal.io', url: 'https://brutal.io/', icon: '🏎️' },
    { title: 'Wings.io', url: 'https://wings.io/', icon: '✈️' },
    { title: 'WormsZone', url: 'https://worms.zone/', icon: '🐛' },
    { title: 'Snake.is', url: 'https://snake.is/', icon: '🐍' },
    { title: 'Snowball.io', url: 'https://snowball-io.com/', icon: '⛄' },
    { title: 'Aquapark.io', url: 'https://aquapark-io.com/', icon: '🌊' },
    { title: 'Taming.io', url: 'https://taming.io/', icon: '🐾' },
    { title: 'Defly.io', url: 'https://defly.io/', icon: '🚁' },
    { title: 'Gartic.io', url: 'https://gartic.io/', icon: '✏️' },
    { title: 'Drawize', url: 'https://www.drawize.com/', icon: '🖍️' },
    { title: 'GeoGuessr', url: 'https://www.geoguessr.com/', icon: '🌍' },
    { title: 'Typing Club', url: 'https://www.typingclub.com/', icon: '⌨️' },
    { title: 'Monkeytype', url: 'https://monkeytype.com/', icon: '🐒' },
    { title: 'Nitro Type', url: 'https://www.nitrotype.com/', icon: '🏎️' },
    { title: '10FastFingers', url: 'https://10fastfingers.com/', icon: '🖐️' },
    { title: 'Chess.com', url: 'https://www.chess.com/', icon: '♟️' },
    { title: 'Lichess', url: 'https://lichess.org/', icon: '♞' },
    { title: 'CoolMathGames', url: 'https://www.coolmathgames.com/', icon: '🧮' },
    { title: 'Moto X3M', url: 'https://poki.com/en/g/moto-x3m', icon: '🏍️' },
    { title: 'Subway Surfers', url: 'https://poki.com/en/g/subway-surfers', icon: '🚇' },
    { title: 'Stickman Hook', url: 'https://poki.com/en/g/stickman-hook', icon: '🤸' },
    { title: 'Temple Run 2', url: 'https://poki.com/en/g/temple-run-2', icon: '🏃' },
    { title: 'Crossy Road', url: 'https://poki.com/en/g/crossy-road', icon: '🐔' },
    { title: 'Drive Mad', url: 'https://poki.com/en/g/drive-mad', icon: '🚗' },
    { title: 'Monkey Mart', url: 'https://poki.com/en/g/monkey-mart', icon: '🛒' },
    { title: 'Vectaria.io', url: 'https://vectaria.io/', icon: '⛏️' },
    { title: 'Tribals.io', url: 'https://tribals.io/', icon: '🏝️' },
    { title: 'Narrow.one', url: 'https://narrow.one/', icon: '🏹' },
    { title: 'Vortex9', url: 'https://poki.com/en/g/vortex-9', icon: '🌀' },
    { title: 'Blockpost', url: 'https://poki.com/en/g/blockpost', icon: '🧱' },
    { title: 'Sniper vs Dinosaurs', url: 'https://poki.com/en/g/sniper-vs-dinosaurs', icon: '🦖' },
    { title: 'Who Is?', url: 'https://poki.com/en/g/who-is', icon: '🤔' },
    { title: 'Brain Test', url: 'https://poki.com/en/g/brain-test', icon: '🧠' },
    { title: 'Raft Wars', url: 'https://poki.com/en/g/raft-wars', icon: '🛶' },
    { title: 'Water Color Sort', url: 'https://poki.com/en/g/water-color-sort', icon: '🧪' },
    { title: 'Idle Ants', url: 'https://poki.com/en/g/idle-ants', icon: '🐜' },
    { title: 'Idle Lumber Inc', url: 'https://poki.com/en/g/idle-lumber-inc', icon: '🪓' },
    { title: 'Tiny Fishing', url: 'https://poki.com/en/g/tiny-fishing', icon: '🎣' },
    { title: 'Murder', url: 'https://poki.com/en/g/murder', icon: '🔪' },
    { title: 'Make It Meme', url: 'https://poki.com/en/g/make-it-meme', icon: '🤣' },
    { title: 'Smash Hit', url: 'https://poki.com/en/g/smash-hit', icon: '💥' },
    { title: 'Super Mario 64', url: 'https://froggi.es/mario/', icon: '🍄' },
    { title: 'Minecraft Classic', url: 'https://classic.minecraft.net/', icon: '⛏️' },
    { title: 'Friday Night Funkin', url: 'https://ninja-muffin24.itch.io/funkin', icon: '🎤' },
    { title: 'Townscaper', url: 'https://oskarstalberg.com/Townscaper/', icon: '🏘️' },
    { title: 'A Dark Room', url: 'https://adarkroom.doublespeakgames.com/', icon: '🔥' },
    { title: 'Cookie Clicker', url: 'https://orteil.dashnet.org/cookieclicker/', icon: '🍪' },
    { title: 'Universal Paperclips', url: 'https://www.decisionproblem.com/paperclips/', icon: '📎' },
    { title: 'Spaceplan', url: 'http://jhollands.co.uk/spaceplan/', icon: '🛰️' },
    { title: 'Melvor Idle', url: 'https://melvoridle.com/', icon: '⚔️' },
    { title: 'Prosperity', url: 'https://www.prosperity-game.com/', icon: '🏰' },
    { title: 'Swarm Simulator', url: 'https://swarmsim.github.io/', icon: '🐛' },
    { title: 'Kittens Game', url: 'https://bloodrizer.ru/games/kittens/', icon: '🐱' },
    { title: 'Sandspiel', url: 'https://sandspiel.club/', icon: '⏳' },
    { title: 'Powder Game', url: 'https://dan-ball.jp/en/javagame/dust/', icon: '💥' },
    { title: 'Falling Sand', url: 'https://thisissand.com/', icon: '🏜️' },
    { title: 'Lines Rider', url: 'https://www.linerider.com/', icon: '🛷' },
    { title: 'Draw a Stickman', url: 'https://drawastickman.com/', icon: '🖌️' },
    { title: 'QWOP', url: 'http://www.foddy.net/Athletics.html', icon: '🏃' },
    { title: 'GIRP', url: 'http://www.foddy.net/GIRP.html', icon: '🧗' },
    { title: 'Sort the Court', url: 'https://graebor.itch.io/sort-the-court', icon: '👑' },
    { title: 'Littlewood', url: 'https://seansyoung.itch.io/littlewood', icon: '🌳' },
    { title: 'Spelunky HTML5', url: 'https://spelunky-html5.github.io/', icon: '⛏️' },
    { title: 'Celeste Classic', url: 'https://www.lexaloffle.com/bbs/?tid=2145', icon: '🍓' },
    { title: 'DOOM', url: 'https://js-dos.com/games/doom.exe.html', icon: '👹' },
    { title: 'Wolfenstein 3D', url: 'https://js-dos.com/games/wolf3d.exe.html', icon: '🏰' },
    { title: 'Prince of Persia', url: 'https://js-dos.com/games/prince.exe.html', icon: '👑' },
    { title: 'SimCity 2000', url: 'https://playclassic.games/games/city-building-dos-games-online/play-simcity-2000-online/', icon: '🏙️' },
    { title: 'Lemmings', url: 'https://www.retrogames.cz/play_164-DOS.php', icon: '🐹' },
    { title: 'Command & Conquer', url: 'https://www.myabandonware.com/game/command-conquer-2h6/play-2h6', icon: '⚔️' },
    { title: 'Dune II', url: 'https://epicport.com/en/dune2', icon: '🏜️' },
    { title: 'Transport Tycoon', url: 'https://epicport.com/en/ttd', icon: '🚂' }
  ];

  static render(container: HTMLElement, onLaunchGame: (gameId: string) => void): void {
    const isAdmin = AuthStore.isAdmin;

    container.innerHTML = `
      <div style="max-width: 1200px; margin: 30px auto; padding: 0 20px; width: 100%;">
        
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; flex-wrap: wrap; gap: 16px;">
          <div>
            <div style="display: flex; align-items: center; gap: 10px;">
              <h2 style="font-size: 2.2rem; font-weight: 900;" class="gradient-text">🌌 Niş & Web Oyun Laboratuvarı</h2>
              ${isAdmin ? `<span style="background: linear-gradient(135deg, #a855f7, #6366f1); color: #fff; font-size: 0.75rem; font-weight: 800; padding: 4px 12px; border-radius: 20px; box-shadow: 0 4px 12px rgba(168,85,247,0.4);">🛡️ YÖNETİCİ MODU AKTİF</span>` : ''}
            </div>
            <p style="color: #94a3b8; font-size: 0.92rem; margin-top: 4px;">Deneysel konsept oyun ve onaylı harici web oyunları kütüphanesi.</p>
          </div>

          <div style="display: flex; gap: 10px; background: rgba(30, 41, 59, 0.8); padding: 6px; border-radius: 14px; border: 1px solid #334155;">
            <button id="tab-exp-btn" class="hub-tab-btn ${this.activeSubTab === 'experimental' ? 'hub-tab-btn--active' : ''}">
              🧪 Niş Konsept Oyunlar (${NICHE_GAMES_LIST.length})
            </button>
            <button id="tab-imp-btn" class="hub-tab-btn ${this.activeSubTab === 'importer' ? 'hub-tab-btn--active' : ''}">
              🌐 Harici Web Oyunları
            </button>
            <button id="tab-ideas-btn" class="hub-tab-btn ${this.activeSubTab === 'ideas' ? 'hub-tab-btn--active' : ''}">
              💡 Oyun Fikrim Var
            </button>
          </div>
        </div>

        ${this.activeSubTab === 'experimental' ? this.renderExperimentalTab() : this.activeSubTab === 'importer' ? this.renderImporterTab(isAdmin) : this.renderIdeasTab(isAdmin)}
      </div>
    `;

    if (!document.getElementById('hub-tab-styles')) {
      const style = document.createElement('style');
      style.id = 'hub-tab-styles';
      style.innerHTML = `
        .hub-tab-btn {
          padding: 8px 18px;
          background: transparent;
          color: #94a3b8;
          border: none;
          border-radius: 10px;
          font-weight: 700;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .hub-tab-btn:hover {
          color: #f8fafc;
          background: rgba(148, 163, 184, 0.1);
        }
        .hub-tab-btn--active {
          background: linear-gradient(135deg, #6366f1, #a855f7);
          color: #fff;
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
        }
        .hub-tab-btn--active:hover {
          background: linear-gradient(135deg, #4f46e5, #9333ea);
          color: #fff;
        }
        .niche-card {
          background: rgba(15, 23, 42, 0.6);
          border: 1px solid #334155;
          border-radius: 16px;
          padding: 24px;
          display: flex;
          flex-direction: column;
          transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        .niche-card:hover {
          transform: translateY(-5px);
          border-color: #6366f1;
          box-shadow: 0 10px 25px rgba(99, 102, 241, 0.15);
        }
        .play-btn-animated {
          margin-top: auto;
          width: 100%;
          padding: 12px;
          background: rgba(99, 102, 241, 0.1);
          color: #818cf8;
          border: 1px solid rgba(99, 102, 241, 0.3);
          border-radius: 10px;
          font-weight: 800;
          font-size: 0.95rem;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .play-btn-animated:hover {
          background: linear-gradient(135deg, #6366f1, #a855f7);
          color: #fff;
          border-color: transparent;
          box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4);
        }
      `;
      document.head.appendChild(style);
    }

    this.attachEvents(container, onLaunchGame);
  }

  private static renderExperimentalTab(): string {
    const total = NICHE_GAMES_LIST.length;
    const totalPages = Math.ceil(total / this.itemsPerPage);
    const start = (this.expPage - 1) * this.itemsPerPage;
    const currentGames = NICHE_GAMES_LIST.slice(start, start + this.itemsPerPage);

    return `
      <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 24px; margin-bottom: 30px;">
        ${currentGames.map(
          (game) => `
          <div class="niche-card" style="padding: 20px; display: flex; flex-direction: column; justify-content: space-between;">
            <div>
              <div style="height: 170px; background: #0f172a; border-radius: 10px; overflow: hidden; margin-bottom: 14px; border: 1px solid #334155;">
                <img src="${game.thumbnail}" alt="${game.title}" style="width: 100%; height: 100%; object-fit: cover;" onerror="this.onerror=null; this.src='/assets/arcade_fallback.png';"/>
              </div>
              <h3 style="font-size: 1.25rem; font-weight: 800; margin-bottom: 8px;">${game.title}</h3>
              <p style="color: #94a3b8; font-size: 0.85rem; line-height: 1.5; margin-bottom: 16px;">${game.description}</p>
              
              <div style="display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 20px;">
                ${game.tags.map((tag) => `<span style="background: rgba(148, 163, 184, 0.1); color: #cbd5e1; font-size: 0.7rem; font-weight: 600; padding: 4px 10px; border-radius: 12px; border: 1px solid #334155;">${tag}</span>`).join('')}
              </div>
            </div>

            <button data-launch-niche="${game.id}" class="play-btn-animated">
              ▶ OYNA
            </button>
          </div>
        `
        ).join('')}
      </div>
      
      ${totalPages > 1 ? `
      <div style="display: flex; justify-content: center; gap: 15px; margin-bottom: 40px; align-items: center;">
        <button id="exp-prev-btn" ${this.expPage === 1 ? 'disabled' : ''} style="padding: 10px 20px; border-radius: 8px; background: ${this.expPage === 1 ? '#334155' : '#6366f1'}; color: #fff; border: none; cursor: ${this.expPage === 1 ? 'not-allowed' : 'pointer'}; font-weight: bold;">Önceki</button>
        <span style="color: #cbd5e1; font-weight: bold;">Sayfa ${this.expPage} / ${totalPages}</span>
        <button id="exp-next-btn" ${this.expPage === totalPages ? 'disabled' : ''} style="padding: 10px 20px; border-radius: 8px; background: ${this.expPage === totalPages ? '#334155' : '#6366f1'}; color: #fff; border: none; cursor: ${this.expPage === totalPages ? 'not-allowed' : 'pointer'}; font-weight: bold;">Sonraki</button>
      </div>
      ` : ''}
    `;
  }

  private static renderImporterTab(isAdmin: boolean): string {
    const total = this.externalGames.length;
    const totalPages = Math.ceil(total / this.itemsPerPage);
    const start = (this.impPage - 1) * this.itemsPerPage;
    const currentGames = this.externalGames.slice(start, start + this.itemsPerPage);

    return `
      <div style="display: flex; flex-direction: column; gap: 30px;">
        ${isAdmin ? `
          <div class="glass-panel" style="padding: 28px; border-radius: 20px; border: 2px solid #a855f7; background: rgba(168, 85, 247, 0.05);">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
              <span style="font-size: 1.5rem;">🔌</span>
              <h3 style="font-size: 1.3rem; font-weight: 800;" class="gradient-text">Yönetici Paneli: Yeni Harici Web Oyunu Ekle</h3>
            </div>
            <p style="color: #94a3b8; font-size: 0.88rem; margin-bottom: 20px;">
              Admin yetkisiyle onaylanan HTML5 web oyun URL'lerini ekleyebilirsiniz.
            </p>

            <form id="embed-game-form" style="display: flex; gap: 12px; flex-wrap: wrap;">
              <input type="text" id="embed-title" placeholder="Oyun Başlığı (Örn: 2048)" required style="padding: 12px 16px; background: #0f172a; border: 1px solid #334155; border-radius: 10px; color: #fff; width: 220px; outline: none;">
              <input type="url" id="embed-url" placeholder="Web Oyun URL (https://...)" required style="padding: 12px 16px; background: #0f172a; border: 1px solid #334155; border-radius: 10px; color: #fff; flex: 1; min-width: 280px; outline: none;">
              <button type="submit" style="padding: 12px 24px; background: linear-gradient(135deg, #a855f7, #6366f1); color: #fff; border-radius: 10px; font-weight: 800; font-size: 0.95rem; box-shadow: 0 4px 14px rgba(168, 85, 247, 0.4);">
                ➕ Oyunu Portala Yayınla
              </button>
            </form>
          </div>
        ` : `
          <div class="glass-panel" style="padding: 20px 24px; border-radius: 14px; display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex; align-items: center; gap: 12px;">
              <span style="font-size: 1.5rem;">🔒</span>
              <p style="color: #94a3b8; font-size: 0.88rem;">
                Harici web oyunları yönetici ekibimiz tarafından incelenip onaylandıktan sonra bu kütüphaneye eklenmektedir.
              </p>
            </div>
            <button id="test-admin-login-btn" style="padding: 8px 16px; background: rgba(168, 85, 247, 0.2); color: #c084fc; border: 1px solid rgba(168, 85, 247, 0.4); border-radius: 8px; font-weight: 700; font-size: 0.82rem; white-space: nowrap;">
              🔑 Admin Hesabıyla Giriş Yap
            </button>
          </div>
        `}

        <div>
          <h3 style="font-size: 1.3rem; font-weight: 800; margin-bottom: 16px;">🌐 Onaylı Harici Web Oyunları</h3>
          <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 20px; margin-bottom: 30px;">
            ${currentGames.map((g, idx) => `
              <div class="glass-panel" style="padding: 20px; display: flex; align-items: center; justify-content: space-between; gap: 16px;">
                <div style="display: flex; align-items: center; gap: 12px; overflow: hidden;">
                  <span style="font-size: 2.2rem;">${g.icon}</span>
                  <div style="overflow: hidden;">
                    <h4 style="font-size: 1.05rem; font-weight: 800;">${g.title}</h4>
                    <span style="font-size: 0.75rem; color: #818cf8; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px; display: block;">${g.url}</span>
                  </div>
                </div>

                <div style="display: flex; align-items: center; gap: 6px;">
                  <button data-play-embed="${g.url}" style="padding: 8px 16px; background: linear-gradient(135deg, #6366f1, #a855f7); color: #fff; border-radius: 8px; font-weight: 700; font-size: 0.85rem;">
                    ▶ Oyna
                  </button>
                  ${isAdmin ? `<button data-delete-embed="${start + idx}" style="padding: 8px; background: rgba(239, 68, 68, 0.2); color: #ef4444; border: 1px solid rgba(239, 68, 68, 0.4); border-radius: 8px; font-weight: 700;" title="Oyunu Sil">🗑️</button>` : ''}
                </div>
              </div>
            `).join('')}
          </div>
          
          ${totalPages > 1 ? `
          <div style="display: flex; justify-content: center; gap: 15px; margin-bottom: 40px; align-items: center;">
            <button id="imp-prev-btn" ${this.impPage === 1 ? 'disabled' : ''} style="padding: 10px 20px; border-radius: 8px; background: ${this.impPage === 1 ? '#334155' : '#6366f1'}; color: #fff; border: none; cursor: ${this.impPage === 1 ? 'not-allowed' : 'pointer'}; font-weight: bold;">Önceki</button>
            <span style="color: #cbd5e1; font-weight: bold;">Sayfa ${this.impPage} / ${totalPages}</span>
            <button id="imp-next-btn" ${this.impPage === totalPages ? 'disabled' : ''} style="padding: 10px 20px; border-radius: 8px; background: ${this.impPage === totalPages ? '#334155' : '#6366f1'}; color: #fff; border: none; cursor: ${this.impPage === totalPages ? 'not-allowed' : 'pointer'}; font-weight: bold;">Sonraki</button>
          </div>
          ` : ''}
        </div>

      </div>
    `;
  }

  private static renderIdeasTab(isAdmin: boolean): string {
    return `
      <div style="display: flex; flex-direction: column; gap: 30px;">
        <div class="glass-panel" style="padding: 28px; border-radius: 20px; border: 2px solid #22c55e; background: rgba(34, 197, 94, 0.05);">
          <h3 style="font-size: 1.5rem; font-weight: 800; margin-bottom: 10px;" class="gradient-text">Oyun Fikri Gönder</h3>
          <p style="color: #94a3b8; font-size: 0.9rem; margin-bottom: 20px;">Harika bir fikrin mi var? Bize gönder, yapay zeka ile hemen prototipini üretelim!</p>
          <form id="idea-form" style="display: flex; flex-direction: column; gap: 15px;">
            <input type="text" id="idea-title" placeholder="Oyunun Adı" required style="padding: 12px; background: #0f172a; border: 1px solid #334155; border-radius: 10px; color: #fff;">
            <input type="text" id="idea-genre" placeholder="Türü (Örn: Platform, Bulmaca)" required style="padding: 12px; background: #0f172a; border: 1px solid #334155; border-radius: 10px; color: #fff;">
            <textarea id="idea-mechanics" placeholder="Oynanış Mekanikleri ve Kurallar" required style="padding: 12px; background: #0f172a; border: 1px solid #334155; border-radius: 10px; color: #fff; min-height: 100px;"></textarea>
            <button type="submit" style="padding: 12px; background: linear-gradient(135deg, #22c55e, #10b981); color: #fff; border-radius: 10px; font-weight: 800; font-size: 1rem; cursor: pointer; border: none; outline: none;">🚀 Fikri Gönder</button>
          </form>
        </div>

        ${isAdmin ? `
          <div class="glass-panel" style="padding: 28px; border-radius: 20px; border: 2px solid #a855f7; background: rgba(168, 85, 247, 0.05);">
            <h3 style="font-size: 1.5rem; font-weight: 800; margin-bottom: 10px;" class="gradient-text">Admin: Gelen Fikirler (AI Generator)</h3>
            <div id="admin-ideas-list" style="display: flex; flex-direction: column; gap: 10px;">
              <span style="color: #94a3b8;">Yükleniyor...</span>
            </div>
          </div>
        ` : ''}
      </div>
    `;
  }

  private static attachEvents(container: HTMLElement, onLaunchGame: (gameId: string) => void): void {
    container.querySelector('#test-admin-login-btn')?.addEventListener('click', () => {
      AuthModal.show('login');
    });

    container.querySelectorAll('[data-launch-niche]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const id = (e.currentTarget as HTMLElement).getAttribute('data-launch-niche');
        if (id) {
          const game = NICHE_GAMES_LIST.find((g) => g.id === id);
          ToastManager.show(`🚀 '${game ? game.title : id}' oyunu başlatılıyor...`, 'success');
          onLaunchGame(id);
        }
      });
    });

    const renderTabs = () => this.render(container, onLaunchGame);

    container.querySelector('#exp-prev-btn')?.addEventListener('click', () => {
      if (this.expPage > 1) { this.expPage--; renderTabs(); }
    });
    container.querySelector('#exp-next-btn')?.addEventListener('click', () => {
      const totalPages = Math.ceil(NICHE_GAMES_LIST.length / this.itemsPerPage);
      if (this.expPage < totalPages) { this.expPage++; renderTabs(); }
    });

    container.querySelector('#imp-prev-btn')?.addEventListener('click', () => {
      if (this.impPage > 1) { this.impPage--; renderTabs(); }
    });
    container.querySelector('#imp-next-btn')?.addEventListener('click', () => {
      const totalPages = Math.ceil(this.externalGames.length / this.itemsPerPage);
      if (this.impPage < totalPages) { this.impPage++; renderTabs(); }
    });

    container.querySelector('#tab-exp-btn')?.addEventListener('click', () => {
      this.activeSubTab = 'experimental';
      renderTabs();
    });

    container.querySelector('#tab-imp-btn')?.addEventListener('click', () => {
      this.activeSubTab = 'importer';
      renderTabs();
    });

    container.querySelector('#tab-ideas-btn')?.addEventListener('click', () => {
      this.activeSubTab = 'ideas';
      renderTabs();
    });

    container.querySelectorAll('[data-play-embed]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const url = (e.currentTarget as HTMLElement).getAttribute('data-play-embed');
        if (url) {
          this.playEmbedGame(url);
        }
      });
    });

    const embedForm = container.querySelector('#embed-game-form') as HTMLFormElement;
    if (embedForm) {
      embedForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const titleInput = document.getElementById('embed-title') as HTMLInputElement;
        const urlInput = document.getElementById('embed-url') as HTMLInputElement;
        
        if (titleInput.value && urlInput.value) {
          this.externalGames.unshift({
            title: titleInput.value,
            url: urlInput.value,
            icon: '🌐'
          });
          ToastManager.show('Oyun başarıyla eklendi!', 'success');
          renderTabs();
        }
      });
    }

    container.querySelectorAll('[data-delete-embed]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        const idx = parseInt((e.currentTarget as HTMLElement).getAttribute('data-delete-embed') || '-1');
        if (idx >= 0) {
          if (await DialogManager.confirm('Bu harici oyunu silmek istediğinize emin misiniz?')) {
            this.externalGames.splice(idx, 1);
            ToastManager.show('Oyun silindi.', 'info');
            renderTabs();
          }
        }
      });
    });

    // Ideas Form Event
    const ideaForm = container.querySelector('#idea-form') as HTMLFormElement;
    if (ideaForm) {
      ideaForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = ideaForm.querySelector('button') as HTMLButtonElement;
        const origText = btn.textContent;
        btn.textContent = 'Gönderiliyor...';
        btn.disabled = true;

        const title = (document.getElementById('idea-title') as HTMLInputElement).value;
        const genre = (document.getElementById('idea-genre') as HTMLInputElement).value;
        const mechanics = (document.getElementById('idea-mechanics') as HTMLTextAreaElement).value;

        const user = AuthStore.getUser();
        if (!user) {
          ToastManager.show('Fikir göndermek için giriş yapmalısınız.', 'error');
          btn.textContent = origText;
          btn.disabled = false;
          return;
        }

        try {
          if (ApiClient.isSupabase) {
            const { error } = await supabase.from('game_ideas').insert({
              user_id: user.id,
              title,
              genre,
              mechanics,
              description: genre // fallback
            });
            if (error) throw error;
            ToastManager.show('Fikriniz başarıyla gönderildi!', 'success');
            ideaForm.reset();
            
            // Reload ideas list if admin
            if (AuthStore.isAdmin) {
              this.loadAdminIdeas(container);
            }
          }
        } catch (err) {
          console.error('Supabase Error:', err);
          ToastManager.show('Gönderilirken hata oluştu.', 'error');
        } finally {
          btn.textContent = origText;
          btn.disabled = false;
        }
      });
    }

    // Load ideas for admin
    if (this.activeSubTab === 'ideas' && AuthStore.isAdmin) {
      this.loadAdminIdeas(container);
    }
  }

  private static async loadAdminIdeas(container: HTMLElement) {
    try {
      const list = container.querySelector('#admin-ideas-list');
      if (!list) return;

      const { ApiClient } = await import('../../services/ApiClient');
      if (ApiClient.isSupabase) {
        const { supabase } = await import('../../services/supabase');
        const { data, error } = await supabase.from('game_ideas').select('*, profiles(username)');
        if (error) throw error;

        if (!data || data.length === 0) {
          list.innerHTML = '<span style="color: #64748b;">Henüz fikir gönderilmemiş.</span>';
          return;
        }

        list.innerHTML = data.map((idea: any) => `
          <div style="background: rgba(15, 23, 42, 0.8); padding: 16px; border-radius: 10px; border: 1px solid #334155; margin-bottom: 10px;">
            <div style="display: flex; justify-content: space-between;">
              <h4 style="font-weight: 800; color: #f8fafc; font-size: 1.1rem;">${idea.title} <span style="font-size:0.8rem; color:#818cf8;">(${idea.genre})</span></h4>
              <span style="font-size: 0.8rem; background: #334155; padding: 2px 8px; border-radius: 10px;">Gönderen: ${idea.profiles?.username || 'Bilinmiyor'}</span>
            </div>
            <p style="color: #cbd5e1; font-size: 0.9rem; margin-top: 8px;">${idea.mechanics}</p>
            <div style="margin-top: 12px; display: flex; gap: 10px; flex-wrap: wrap;">
              <button class="ai-generate-btn" style="background: linear-gradient(135deg, #a855f7, #d946ef); padding: 6px 12px; border-radius: 6px; font-weight: bold; border: none; color: white; cursor: pointer;">🪄 AI ile Kod Üret</button>
              <button data-idea-status="${idea.id}" style="background: rgba(34, 197, 94, 0.2); border: 1px solid rgba(34, 197, 94, 0.4); color: #22c55e; padding: 6px 12px; border-radius: 6px; font-weight: bold; cursor: pointer;">✅ Onayla</button>
              <button data-idea-delete="${idea.id}" style="background: rgba(239, 68, 68, 0.2); border: 1px solid rgba(239, 68, 68, 0.4); color: #ef4444; padding: 6px 12px; border-radius: 6px; font-weight: bold; cursor: pointer;">🗑️ Sil</button>
            </div>
          </div>
        `).join('');

        list.querySelectorAll('.ai-generate-btn').forEach(btn => {
          btn.addEventListener('click', async () => {
            await DialogManager.alert('AI entegrasyonu simülasyonu çalışıyor...');
          });
        });

        list.querySelectorAll('[data-idea-delete]').forEach(btn => {
          btn.addEventListener('click', async (e) => {
            const id = (e.currentTarget as HTMLElement).getAttribute('data-idea-delete');
            if (id && await DialogManager.confirm('Bu fikri silmek istediğinize emin misiniz?')) {
              await supabase.from('game_ideas').delete().eq('id', id);
              ToastManager.show('Fikir silindi.', 'info');
              this.loadAdminIdeas(container);
            }
          });
        });

        list.querySelectorAll('[data-idea-status]').forEach(btn => {
          btn.addEventListener('click', async (e) => {
            const id = (e.currentTarget as HTMLElement).getAttribute('data-idea-status');
            if (id) {
              ToastManager.show('Fikir durumu güncellendi.', 'success');
              // Here you would typically update a status field in the DB.
            }
          });
        });
      }
    } catch(err) {
      console.error(err);
    }
  }

  private static playEmbedGame(url: string): void {
    const overlay = document.createElement('div');
    overlay.className = 'ad-interstitial-overlay';
    overlay.style.zIndex = '100000';
    overlay.style.backdropFilter = 'blur(10px)';

    overlay.innerHTML = `
      <div style="width: 90%; height: 90%; max-width: 1200px; background: #000; border: 2px solid #334155; border-radius: 16px; overflow: hidden; position: relative; display: flex; flex-direction: column;">
        
        <div style="background: #0f172a; padding: 12px 20px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #334155;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <span style="color: #22c55e; font-size: 1.2rem;">🌐</span>
            <span style="color: #fff; font-weight: 700; font-size: 0.95rem;">Harici Oyun Bağlantısı</span>
          </div>
          <button id="close-embed-btn" style="background: #ef4444; color: #fff; border: none; padding: 6px 12px; border-radius: 6px; font-weight: 800; cursor: pointer;">Kapat ✖</button>
        </div>

        <iframe src="${url}" style="width: 100%; flex: 1; border: none;" allow="autoplay; fullscreen; gamepad"></iframe>
      </div>
    `;

    document.body.appendChild(overlay);

    overlay.querySelector('#close-embed-btn')?.addEventListener('click', () => overlay.remove());
  }
}

